export default "__VITE_ASSET__BTW9_rft__"